import validate from "/usr/src/app/content/n3-spas-4be1be69-ad12-46be-84a0-5465fca1372b/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-4be1be69-ad12-46be-84a0-5465fca1372b/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}